// extracted by mini-css-extract-plugin
export default {"Modal":"PositionCardModal_Modal__UGHuY","Overlay":"PositionCardModal_Overlay__om2ov"};